// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7490543e","453":"165f2cea","455":"70377e52"}[chunkId] + ".chunk.js";
};